import React, { Component, Fragment } from 'react';
import Header from './Header';
import CSVGenerator from '../utils/json2csv';
import _ from 'lodash';
import moment from 'moment';
import Table from './Table';
import { getLedgerBasedBillingReport } from '../utils/PaymentRequestApiUtils';
import { TextField, Button, Snackbar, LinearProgress, Dialog, DialogContent } from '@material-ui/core';
import { getLedgerBasedBillingReportCSVData } from './Reports';
import { businessUnitMap, statusMap } from '../constants/paymentStatus';
import { billTypeList } from '../constants/billTypeList';

class LedgerBasedBillingReport extends Component{
    constructor(){
        super();
        this.state = {
            data: [],
            fromDate: '',
            toDate: '',
            fromDateShow: '',
            toDateShow: '',
            fromDateErr: false,
            fromDateErrText: '',
            toDateErr: false,
            toDateErrText: '',
            inProgress: false,
            snackMessage: "",
            snackOpen: false,
            validationsDialogOpen: false,
            validationErrors: [],
            dialogBoxText: "",
            showDownloadButton: false,
            paymentsReportColumns: [],
            accountingReportColumns: [],
            billSubmissionReportColumns: [],
            ledgerBasedBillingReportColumns: [],
            buList: businessUnitMap || {},
        }
        this.handleChange = this.handleChange.bind(this);
        this.submitFilter = this.submitFilter.bind(this);
        this.clearFilter = this.clearFilter.bind(this);
        this.generateCSV = this.generateCSV.bind(this);
        this.handleCloseSnack = this.handleCloseSnack.bind(this);
        this.handleFetchData = this.handleFetchData.bind(this);
        // this.handleFetchBuList = this.handleFetchBuList.bind(this);
    }

    componentWillMount(){
        this.setState({
            showDownloadButton: true, 
            paymentsReportColumns: this.props.location.state.paymentsReportColumns, 
            accountingReportColumns: this.props.location.state.accountingReportColumns,
            billSubmissionReportColumns: this.props.location.state.billSubmissionReportColumns,
            ledgerBasedBillingReportColumns: this.props.location.state.ledgerBasedBillingReportColumns,
        })
    }
    componentDidMount(){
        this.handleFetchData()
        // this.handleFetchBuList()
    }

    handleChange = (props) => (event, index, value) => {
        this.setState({ [props]: event.target.value, [props + 'Err']: false, [props + 'ErrText']: '' })
    }

    async submitFilter() {

        if (this.state.toDateShow !== '' && this.state.toDateShow < this.state.fromDateShow) {
            this.setState({ snackOpen: true, snackMessage: 'From date should be less than To date' })
            return
        }
        
        if (this.state.fromDateShow !== '' && this.state.fromDateShow > this.state.toDateShow) {
            this.setState({ snackOpen: true, snackMessage: 'To date should be greater than From date' })
            return
        }
        this.setState({fromDate: this.state.fromDateShow, toDate: this.state.toDateShow}, () =>
            this.handleFetchData({from_date: this.state.fromDate, to_date: this.state.toDate})
        )
        
    }

    handleFetchData(filters = {}){
        this.setState({ inProgress: true },() => {
          getLedgerBasedBillingReport(filters).then(response => {
                if (response) {
                    if (response.status === 'success') {
                        let data = response.data.map(data => {
                            return { 
                                ...data,
                                date_of_invoice: (data.date_of_invoice)?moment(data.date_of_invoice).format('DD-MM-YYYY'): '-',
                                invoice_due_date: (data.invoice_due_date)?moment(data.invoice_due_date).format('DD-MM-YYYY'): '-',
                                bill_type: data.bill_type ? billTypeList.find(billType => billType.value === data.bill_type) && billTypeList.find(billType => billType.value === data.bill_type).label : '',
                                business_unit: data.business_unit ? this.state.buList[data.business_unit] && this.state.buList[data.business_unit].value : '',
                                status: data.status && statusMap[data.status] ? statusMap[data.status].value : '',
                            }
                        })
                        this.setState({ data, inProgress: false })
                    }
                    else {
                        this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
                    }
                }
            })
        })
    }

    // handleFetchBuList(){
    //     this.setState({ inProgress: true },() => {
    //         fetchBuList().then(response => {
    //             if (response) {
    //                 if (response.status === 'success') {
    //                     this.setState({ buList: response.data, inProgress: false })
    //                 }
    //                 else {
    //                     this.setState({ snackMessage: response.message, snackOpen: true, inProgress: false })
    //                 }
    //             }
    //         })
    //     })
    // }


    handleCloseSnack() {
        this.setState({ snackOpen: false })
    }
    
    clearFilter() {
        this.setState({ fromDate: '', toDate: '', fromDateShow: '', toDateShow: '', fromDateErr: false, fromDateErrText: '', toDateErr: false, toDateErrText: '' })
        this.handleFetchData();
    }

    async generateCSV() {
        let csvData = await getLedgerBasedBillingReportCSVData(this.state.data);
        CSVGenerator(csvData.headers, csvData.data, csvData.filename)
    }

    render(){
        return(
            <Fragment>
                <Header />
        <div className="zaps-page-wrap">
          <div className="zaps-page-header">
            <div>
              <h2 className="zaps-page-title">Provision Report</h2>
              <p className="zaps-page-subtitle">Ledger-based billing breakdown with TDS and GST details</p>
            </div>
          </div>
                <h4 style={{textAlign: 'center'}}>Details showing from {this.state.fromDate && this.state.toDate?this.state.fromDate:moment().startOf('month').format("YYYY-MM-DD")} to {this.state.toDate && this.state.fromDate?this.state.toDate:moment().endOf('month').format("YYYY-MM-DD")}</h4>
                <div style={{ display: 'flex', justifyContent: 'space-between', margin: '20px', flexWrap: 'wrap' }}>
                <div style={{ display: 'flex', flexWrap: 'wrap' }}>
                    <div>
                    Select Transaction Date Range:&nbsp;&nbsp;&nbsp;&nbsp;
                    <TextField
                        id="date"
                        label="From Date"
                        type="date"
                        InputLabelProps={{
                        shrink: true,
                        }}
                        value={this.state.fromDateShow}
                        onChange={this.handleChange('fromDateShow')}
                        style={{ marginRight: '20px' }}
                        error={this.state.fromDateErr}
                        helperText={this.state.fromDateErrText}
                        margin='normal'
                    />
                    <TextField
                        id="date"
                        label="To Date"
                        type="date"
                        InputLabelProps={{
                        shrink: true,
                        }}
                        value={this.state.toDateShow}
                        onChange={this.handleChange('toDateShow')}
                        style={{ marginRight: '20px' }}
                        error={this.state.toDateErr}
                        helperText={this.state.toDateErrText}
                        margin='normal'
                    />
                    </div>
                    <div>
                    <Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' || this.state.toDateShow === ''} onClick={this.submitFilter.bind(this)}
                        style={{ marginRight: '20px', marginTop: '25px' }}>
                        Submit Filter
                        </Button>
                    <Button variant="contained" size="large" color="primary" disabled={this.state.fromDateShow === '' && this.state.toDateShow === ''} onClick={this.clearFilter.bind(this)}
                        style={{ background: 'red', marginTop: '25px' }}>
                        Clear Filter
                        </Button>
                    </div>
                </div>
                <div style={{ marginTop: '25px' }} >
                {this.state.showDownloadButton && <Button variant="contained" size="large" color="primary" disabled={this.state.data.length === 0} onClick={this.generateCSV.bind(this)}
                        style={{ marginRight: '20px'}}>
                        Download CSV
                    </Button>}
                {/* {this.state.showDownloadButton && <Button variant="contained" size="large" color="primary" disabled={this.state.data.length === 0} onClick={this.generateAllCSVs.bind(this)}
                        style={{ marginRight: '20px'}}>
                        Download ALL
                    </Button>} */}
                </div>
    </div>
                <Table columns={this.state.ledgerBasedBillingReportColumns} data={this.state.data} />
                <Dialog
                open={this.state.inProgress}
                aria-labelledby="alert-dialog-title"
                aria-describedby="alert-dialog-description"
                >
                    <DialogContent>
                        Loading...
                        <br/><br/>
                        <LinearProgress />
                    </DialogContent>
                </Dialog>
                <Snackbar
                open={this.state.snackOpen}
                message={this.state.snackMessage}
                autoHideDuration={2500}
                onClose={this.handleCloseSnack.bind(this)}
                />
          
        </div>{/* end zaps-page-wrap */}
      </Fragment>
        )
    }
}

export default LedgerBasedBillingReport;



// WEBPACK FOOTER //
// ./src/components/LedgerBasedBillingReport.js